import React, { Component } from 'react';

class ErrorBoundary extends React.Component {
  static defaultProps = {
    onReload: () => {}
  };
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Error caught:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          padding: 20,
          background: '#ffebee',
          border: '1px solid #ffcdd2',
          borderRadius: 4,
          color: '#c62828',
          maxWidth: 600,
          margin: '20px auto',
          textAlign: 'center'
        }}>
          <h3>Something went wrong</h3>
          <p>{this.state.error?.message || 'An unexpected error occurred'}</p>
          <button
            onClick={() => {
                this.setState({ hasError: false, error: null });
                window.location.reload();
            }}
            style={{
              marginTop: 10,
              padding: '8px 16px',
              background: '#ef5350',
              color: 'white',
              border: 'none',
              borderRadius: 4,
              cursor: 'pointer'
            }}
          >
            Try again
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
